import { render } from "./AiqService.vue?vue&type=template&id=140ababc&scoped=true"
import script from "../js/aiq-service.js?vue&type=script&lang=js"
export * from "../js/aiq-service.js?vue&type=script&lang=js"

import "./AiqService.vue?vue&type=style&index=0&id=140ababc&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140ababc"]])

export default __exports__